import { Button } from "@mui/material";
import { useEffect, useState } from "react";
const Complete = ({ customer = {}, cfg = {} }) => {
    const [redirect, setRedirect] = useState(null);
    const msgs = ["Controlla"];
    if (customer.cellulare) {
        msgs.push("il tuo cellullare")
    }
    if (customer.cellulare && customer.email) {
        msgs.push("oppure")
    }
    if (customer.email) {
        msgs.push("la tua email")
    }
    useEffect(() => {
        if (!cfg.env) return;
        if (cfg.env.properties.iscrizione_redirect_url) {
            setRedirect(cfg.env.properties.iscrizione_redirect_url)
        }
    }, [cfg])
    return <div className="completeFlow">
        <div class="content">
            <p>
                Grazie per esserti iscritto al nostro programma fedeltà! La tua registrazione è andata a buon fine.
            </p>
            <p> <b>{msgs.join(" ")}</b></p>
            <p>
                per trovare la tua nuova Fidelity Card e iniziare a godere dei privilegi riservati ai nostri membri.
                <div><b>Benvenuto nella nostra community!</b></div>
            </p>
            <div>
                {redirect && <Button fullWidth variant="contained" href={redirect}>VAI</Button>}
            </div>
        </div>
    </div >
}
export default Complete;